import React, { useState, useEffect } from 'react'
import BarChart from './UI/Chart/BarChart';
import PieChart from './UI/Chart/PieChart';
import LineChart from './UI/Chart/LineChart';
import SelectList from './UI/Control/SelectList';

const HomeDashboard = (props) => {
    const [siteChartData, setSiteChartData] = useState([]);
    const [visitChartData, setVisitChartData] = useState([]);
    const [taskStageChartData, setTaskStageChartData] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState('false');
    const [arrStudy, setArrStudy] = useState([]);

    useEffect(() => {
        fetchFillStudyList();
    }, [isDataLoaded]); 

    const fetchLoadSiteSubject = (studyId) => {
        fetch('api/Chart/LoadSiteSubject?studyId=' + studyId)
            .then(response => response.json())
            .then(data => {

                let colors = [];

                for (let i = 0; i < data.length; i++) {
                    colors.push('#' + Math.floor(Math.random() * 16777215).toString(16));
                }

                let Sitelabels = new Array();
                let subCount = new Array();

                let Visitlabels = new Array();
                let taskCount = new Array();

                let stagelabels = new Array();
                let stageTaskCount = new Array();

                data.map((item, index) => {
                    if (item.ChartType == 'SiteSubject') {
                        Sitelabels.push(item.Label);
                        subCount.push(item.Data);
                    }
                    else if (item.ChartType == 'VisitTask') {
                        Visitlabels.push(item.Label);
                        taskCount.push(item.Data);
                    }
                    else if (item.ChartType == 'TaskStage') {
                        stagelabels.push(item.Label);
                        stageTaskCount.push(item.Data);
                    }
                });

                let siteChartData = {
                    labels: Sitelabels,
                    datasets: [{
                        label: '# of Subjects',
                        data: subCount,
                        backgroundColor: colors,
                    }]
                }

                let visitChartData = {
                    labels: Visitlabels,
                    datasets: [{
                        label: '# of Tasks',
                        data: taskCount,
                        backgroundColor: colors,
                        
                    }]
                }

                let stageChartData = {
                    labels: stagelabels,
                    datasets: [{
                        label: '# of Tasks',
                        data: stageTaskCount,
                        backgroundColor: colors,
                    }]
                }

                setSiteChartData(siteChartData);
                setVisitChartData(visitChartData);
                setTaskStageChartData(stageChartData);

                setIsDataLoaded('true');
            });
    }

    const fetchFillStudyList = () => {
        fetch('api/Study/FillStudyList')
            .then(response => response.json())
            .then(data => {
                fetchLoadSiteSubject(data[0].Value);
                setArrStudy(data);
            });
    }

    const onStudyReportChangeHandler = (e) => {
        let objStudy = document.getElementById("ddlStudies");
        fetchLoadSiteSubject(objStudy.value);
    }

    return (
        <div className="container-fluid">
            
            <div className="row" style={{ marginTop: "150px" }}>
                <div className="col-sm-2">
                    <SelectList id='ddlStudies' dataSource={arrStudy} onChangeHandler={onStudyReportChangeHandler} />
                </div>
            </div>
            <div className="row" style={{ marginTop: "50px" }}>
                <div className="col-sm-4">
                    {isDataLoaded == 'true' && <BarChart chartData={siteChartData} height="500" width="500"
                        options={{
                            maintainAspectRatio: false,
                            plugins: {
                                title: {
                                    display: true,
                                    text: '# of subjects assigned to site'
                                }
                            }
                        }}></BarChart>}
                </div>
                <div className="col-sm-4">
                    {isDataLoaded == 'true' && <PieChart chartData={visitChartData} height="500" width="500"
                        options={{
                            maintainAspectRatio: false,
                            plugins: {
                                title: {
                                    display: true,
                                    text: '# of tasks assigned to visit'
                                }
                            }
                        }}></PieChart>}
                </div>
                <div className="col-sm-4">
                    {isDataLoaded == 'true' && <LineChart chartData={taskStageChartData} height="500" width="500"
                        options={{
                            maintainAspectRatio: false,
                            plugins: {
                                title: {
                                    display: true,
                                    text: '# of tasks assigned to task stage'
                                }
                            }
                        }}></LineChart>}
                </div>
            </div>
        </div>
    );
};

export default HomeDashboard;
